<template functional>
  <div style="align-content: center">
    <strong><translate-text keyTranslate="common_words.latitude" />: </strong>
    {{ props.row.latitude ? props.row.latitude : 'NA' }}
    <br />
    <strong><translate-text keyTranslate="common_words.longitude" />: </strong>
    {{ props.row.longitude ? props.row.longitude : 'NA' }}
    <br />
    <strong><translate-text keyTranslate="common_words.altitude" />: </strong>
    {{ props.row.altitude ? props.row.altitude : 'NA' }}
    <br />
  </div>
</template>

<script>
export default {
  functional: true,
  name: 'GeoPositionFormatter',
};
</script>
